import { useEffect, useState } from "react";

export default function TimeOnlyField({ label, value, onChange, testId }) {
  const [h, m] = (value || "").split(":");
  const hours = Array.from({ length: 24 }, (_, i) => String(i).padStart(2, "0"));
  const minutes = Array.from({ length: 12 }, (_, i) => String(i * 5).padStart(2, "0"));
  const [text, setText] = useState(value || "");
  useEffect(() => { setText(value || ""); }, [value]);
  const emit = (hh, mm) => onChange(`${hh || h || "08"}:${mm || m || "00"}`);
  const commitText = (raw) => {
    const trimmed = (raw || "").trim();
    if (!trimmed) { setText(value || ""); return; }
    let hh, mm;
    if (trimmed.includes(":")) {
      const [a, b = ""] = trimmed.split(":");
      hh = parseInt(a, 10);
      mm = parseInt(b === "" ? "0" : b, 10);
    } else {
      const digits = trimmed.replace(/[^0-9]/g, "");
      if (!digits) { setText(value || ""); return; }
      if (digits.length <= 2) { hh = parseInt(digits, 10); mm = 0; }
      else { hh = parseInt(digits.slice(0, -2), 10); mm = parseInt(digits.slice(-2), 10); }
    }
    if (Number.isNaN(hh) || Number.isNaN(mm) || hh < 0 || hh > 23 || mm < 0 || mm > 59) {
      setText(value || "");
      return;
    }
    onChange(`${String(hh).padStart(2, "0")}:${String(mm).padStart(2, "0")}`);
  };
  const cls = "px-2 py-2 rounded-md bg-slate-950 border border-slate-800 text-sm focus:border-blue-500 outline-none";
  return (
    <div>
      {label && <label className="block text-[10px] uppercase tracking-widest text-slate-500 font-mono-num mb-1">{label}</label>}
      <div className="flex gap-1.5 items-center">
        <input
          value={text}
          onChange={(e) => setText(e.target.value)}
          onBlur={(e) => commitText(e.target.value)}
          onKeyDown={(e) => { if (e.key === "Enter") { e.preventDefault(); commitText(e.target.value); } }}
          placeholder="hh:mm"
          inputMode="numeric"
          data-testid={testId}
          className={`${cls} w-20 font-mono-num`}
        />
        <select value={h || ""} onChange={(e) => emit(e.target.value, null)} data-testid={`${testId}-hour`} className={`${cls} w-16`}>
          <option value="">hh</option>
          {hours.map((x) => <option key={x} value={x}>{x}</option>)}
        </select>
        <span className="text-slate-600 text-sm">:</span>
        <select value={m || ""} onChange={(e) => emit(null, e.target.value)} data-testid={`${testId}-minute`} className={`${cls} w-16`}>
          <option value="">mm</option>
          {minutes.map((x) => <option key={x} value={x}>{x}</option>)}
        </select>
      </div>
    </div>
  );
}
